"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownForNatLangForm = DropdownForNatLangForm;
var _utils = require("../../middleware/utils");
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _reactBlueprintLibrary = require("react-blueprint-library");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function DropdownForNatLangForm(_ref) {
  var {
    values,
    setFieldValue,
    dropdownArray,
    fieldName,
    preText,
    postText,
    className,
    calcName,
    placeholderProp
  } = _ref;
  var compClass = className ? className : '';
  var placeholder = placeholderProp ? placeholderProp : 'Select One';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: fieldName
  }, preText), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.DropdownSelect, {
    className: compClass,
    data: dropdownArray,
    onSelect: value => {
      (0, _utils.handleDropdownOnSelect)(value, fieldName, setFieldValue, calcName);
    },
    defaultLabel: values[fieldName] != '' ? values[fieldName] : placeholder,
    toggleId: fieldName,
    toggleName: fieldName
  }), className == 'endOfSentence' ? '.' : null), postText);
}